// Module
var code = "<md-content class=\"animated fadeIn\"> <div ng-style=\"{height: $ctrl.screenSize.height + 'px'}\" layout=\"column\" layout-align=\"center center\"> <h2>{{$ctrl.title}}</h2> <p>{{$ctrl.body}}</p> </div> </md-content>";
// Exports
export default code;